import { useTranslation } from "react-i18next";
import getUrlQuery from "../../../../../controllers/getUrlQuery";
import AdminCardsList from "../AdminCardsList";
import ManageActivityBookingCard from "./ManageActivityBookingCard";
import { useContext, useEffect, useState } from "react";
import ActivityTypeFilter from "./ActivityTypeFilter";
import LoadingSection from "../../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../../controllers/network/serverLine";
import CustomButton from "../../../../helperComponents/CustomButton";
import { BiReset } from "react-icons/bi";
import BookingDateFilter from "./BookingDateFilter";
import getDateWithSlash from "../../../../../controllers/getDateWithSlash";
import Context from "../../../../../Context";

export default function ManageActivityBookingsPage({ dashboardType }) {
  const { isAdmin } = useContext(Context);
  const { t } = useTranslation();

  const [activityTypes, setActivityTypes] = useState(null);

  useEffect(() => {
    serverLine.get("/admin/activity-types").then(setActivityTypes);
  }, []);

  const [activityTypeID, setActivityTypeID] = useState(null);
  const [date, setDate] = useState(null);

  let urlQuery = getUrlQuery();

  useEffect(() => {
    if (urlQuery.activityTypeID) setActivityTypeID(urlQuery.activityTypeID);
    if (urlQuery.date) setDate(urlQuery.date);
  }, [urlQuery]);

  if (!activityTypes) return <LoadingSection />;

  let typeFilter = null;

  if (isAdmin) {
    //Employees can't use the type filter
    typeFilter = (
      <ActivityTypeFilter
        value={activityTypeID}
        onChange={setActivityTypeID}
        activityTypes={activityTypes}
      />
    );
  }

  let additionalButtons = [
    typeFilter,

    <BookingDateFilter value={date} onChange={setDate} />,

    <CustomButton
      icon={<BiReset />}
      onClick={() => {
        setActivityTypeID(null);
        setDate(null);
      }}
    />,
  ];

  return (
    <AdminCardsList
      additionalButtons={additionalButtons}
      title={t("adminActivityBookingTitle")}
      path={getPath()}
      dashboardType={dashboardType}
      allowCreation={true}
      CardComponent={ManageActivityBookingCard}
    />
  );

  function getPath() {
    if (!activityTypeID && !date) return `activity-bookings`;

    return `activity-bookings/?${objectToQueryString({
      activityTypeID,
      date: formatFilterDate(date),
    })}`;
  }

  function objectToQueryString(obj) {
    return Object.entries(obj)
      .filter(([_, value]) => value !== null && value !== undefined && value !== "")
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
  }

  function formatFilterDate(value) {
    if (!value) return null;
    if (typeof value !== "string") return null;

    let trimmed = value.trim();
    if (!trimmed) return null;

    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(trimmed)) return trimmed;

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      let dateObj = new Date(`${trimmed}T00:00:00`);
      if (Number.isNaN(dateObj.getTime())) return null;
      return getDateWithSlash(dateObj);
    }

    let dateObj = new Date(trimmed);
    if (Number.isNaN(dateObj.getTime())) return null;
    return getDateWithSlash(dateObj);
  }
}
